var map = {
	"./cheetos.png": 1494,
	"./csv.png": 2299,
	"./doritos.png": 8136,
	"./gamesa.png": 5947,
	"./joy.png": 7640,
	"./login_splash.png": 3341,
	"./lost.png": 5334,
	"./quaker.png": 5225,
	"./sabritas.png": 4740,
	"./xls.png": 9029
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6075;